<template>
	<div class="content-wrapper">
		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-5">
				<sf-card>
					<search-bar class="search-bar" :mainSqlId="mainSqlId" @changeId="changeId" />
				</sf-card>
			</div>
			<div class="sf-col sf-col-19">
				<el-col :span="8" class="h-100" style="padding-top: 10px">
					<parameter-table :parameterRows="parameterRows" @changedRow="changedRow" />
				</el-col>
				<el-col :span="16" style="padding: 10px" class="h-100">
					<el-row style="height: 35%">
						<text-bar :contentText="contentText" @changeText="changeText" />
					</el-row>
					<el-row style="height: 65%">
						<compile-bar :historyRows="historyRows" />
					</el-row>
				</el-col>
			</div>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/SQLEditor/store/helpers';
import SearchBar from './SearchBar.vue';
import ParameterTable from './ParameterTable.vue';
import TextBar from './TextBar.vue';
import CompileBar from './CompileBar.vue';

var convert = require('xml-js');

export default {
	components: {
		SearchBar,
		ParameterTable,
		TextBar,
		CompileBar
	},
	props: {
		mainIndex: { type: String, default: '' }
	},
	data() {
		return {
			mainSqlId: null,
			parameterRows: [],
			contentText: null,
			historyRows: []
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		changeId(param) {
			this.mainSqlId = param;

			const temp = convert.xml2js(this.selectedContent.sqlText);
			temp.elements[0].attributes.id = this.mainSqlId;
			this.contentText = convert.js2xml(temp);

			this.DEFAULT_ASSIGN({
				key: 'selectedContent',
				value: { ...this.selectedContent, sqlId: this.mainSqlId, sqlParameters: this.parameterRows, sqlText: this.contentText }
			});
		},
		changedRow(param) {
			this.parameterRows = param;
			this.DEFAULT_ASSIGN({
				key: 'selectedContent',
				value: { ...this.selectedContent, sqlId: this.mainSqlId, sqlParameters: this.parameterRows, sqlText: this.contentText }
			});
		},
		changeText(param) {
			this.contentText = param;
			this.DEFAULT_ASSIGN({
				key: 'selectedContent',
				value: { ...this.selectedContent, sqlId: this.mainSqlId, sqlParameters: this.parameterRows, sqlText: this.contentText }
			});
		},
		async Initialize() {
			this.$sf_toggleLoading(true);
			if (this.searchParams.sqlId != '') {
				await this.getSqlLog_(this.searchParams.sqlId)
					.then(header => {
						this.$sf_toast({
							...this.$sf_setToastOption(header),
							message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
						});
					})
					.catch(error => {
						this.$sf_toast({ type: 'error', message: error.message });
					});
			}

			// console.warn('current Tab : ', this.mainIndex);
			const activeTabContent = this.sqlContent.filter(content => content.sqlId === this.mainIndex)[0];
			// console.log('activeTabContent', activeTabContent);

			this.mainSqlId = activeTabContent.sqlId;
			this.parameterRows = activeTabContent.sqlParameters;
			this.contentText = activeTabContent.sqlText;

			this.historyRows = activeTabContent.sqlLog;
			// console.log('this.historyRows : table', this.historyRows);

			this.$sf_toggleLoading(false);
		}
	},
	created() {
		this.Initialize();
	},
	watch: {
		mainIndex() {
			this.Initialize();
		}
	}
};
</script>

<style lang="scss">
.colStyle {
	padding-top: 10px;
	// padding-bottom: 10px;
	height: 100%;
}
.rowStyle {
	display: flex;
	flex-direction: column;
}
</style>
